import React from 'react';
import { compose, prop } from 'ramda';
import { defaultProps } from 'recompose';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import Text from 'app/components/layout/Text.styled';
import Styled from 'app/features/couponCampaign/landing/components/HeroBlock.styled';
import {
  havePlansLoaded,
  productCurrency,
  productPriceAmount,
} from 'app/features/plans/selectors';
import { FAN_PACK_FREE_TRIAL_SKU } from 'app/constants/freeTrial';
import { productBillingPeriodKey } from 'app/features/products/selectors';

const UI = ({ amount, currency, billingPeriodKey, translationKey, as }) => (
  <Text size="l" as={as}>
    <FormattedMessage
      id={translationKey}
      values={{
        price: (
          <FormattedNumber
            style="currency"
            currency={currency}
            value={amount}
          />
        ),
        period: <FormattedMessage id={billingPeriodKey} />,
      }}
    />
  </Text>
);

UI.propTypes = {
  amount: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  billingPeriodKey: PropTypes.string.isRequired,
  translationKey: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.symbol, PropTypes.shape()]),
};

UI.defaultProps = {
  translationKey: 'coupon_landing_renewal_notice',
  as: Styled.Notice,
};

UI.displayName = 'Renewal Notice';

const state = {
  havePlansLoaded,
  amount: productPriceAmount,
  currency: productCurrency,
  billingPeriodKey: productBillingPeriodKey,
};

const RenewalNotice = compose(
  defaultProps({ sku: FAN_PACK_FREE_TRIAL_SKU }),
  connect(state),
  renderIf(prop('havePlansLoaded')),
)(UI);

export { UI };

export default RenewalNotice;
